import * as React from 'react';

import {colors} from '../colors/colors';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {Body} from '../typography/body';

type DetailRowProps = {
    value: string | null | undefined | number | null | undefined;
    fallbackText: string;
    IconComponent: React.ComponentType<any>;
};

export function DetailRow({value, fallbackText, IconComponent}: DetailRowProps) {
    return (
        <StackLegacy spacing={8} isHorizontal={true} alignCenter={true}>
            <IconComponent size={13} color={colors.grey} alignCenter={true} />
            <Body size='small' color={value ? 'dark' : 'light'} isItalic={!value}>
                {value || fallbackText}
            </Body>
        </StackLegacy>
    );
}
